 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import PRAISEFORJONATHANMABERRY from '@/components/praise-for-jonathan-maberry'
 import BOOKDESCRIPTION from '@/components/book-description'
 import TITLEPAGE from '@/components/title-page'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import DEDICATION from '@/components/dedication'
 import INTRODUCTION from '@/components/introduction'
 import AUTHORSNOTE from '@/components/authors-note'
 import CHOKEPOINT from '@/components/chokepoint'
 import AUTHORSNOTE2 from '@/components/authors-note-2'
 import FATGIRLWITHAKNIFE from '@/components/fat-girl-with-a-knife'
 import AUTHORSNOTE3 from '@/components/authors-note-3'
 import LONEGUNMAN from '@/components/lone-gunman'
 import AUTHORSNOTE4 from '@/components/authors-note-4'
 import NOTTHISWARNOTTHISWORLD from '@/components/not-this-war-not-this-world'
 import AUTHORSNOTE5 from '@/components/authors-note-5'
 import CALLINGDEATH from '@/components/calling-death'
 import AUTHORSNOTE6 from '@/components/authors-note-6'
 import GAVINFUNKESMONSTERMOVIEMARATHON from '@/components/gavin-funkes-monster-movie-marathon'
 import AUTHORSNOTE7 from '@/components/authors-note-7'
 import CADAVERDOG from '@/components/cadaver-dog'
 import AUTHORSNOTE8 from '@/components/authors-note-8'
 import OVERDUEBOOKS from '@/components/overdue-books'
 import AUTHORSNOTE9 from '@/components/authors-note-9'
 import ASMALLTASTEOFTHEOLDCOUNTRY from '@/components/a-small-taste-of-the-old-country'
 import AUTHORSNOTE10 from '@/components/authors-note-10'
 import SISTERS from '@/components/sisters'
 import AUTHORSNOTE11 from '@/components/authors-note-11'
 import JACKANDJILL from '@/components/jack-and-jill'
 import AUTHORSNOTE12 from '@/components/authors-note-12'
 import THEWINDTHROUGHTHEFENCE from '@/components/the-wind-through-the-fence'
 import AUTHORSNOTE13 from '@/components/authors-note-13'
 import JINGOANDTHEHAMMERMAN from '@/components/jingo-and-the-hammerman'
 import AUTHORSNOTE14 from '@/components/authors-note-14'
 import THEDEATHPOEMOFSENSEIOTORO from '@/components/the-death-poem-of-sensei-otoro'
 import AUTHORSNOTE15 from '@/components/authors-note-15'
 import SONOFTHEDEVIL from '@/components/son-of-the-devil'
 import AUTHORSNOTE16 from '@/components/authors-note-16'
 import PEGLEGANDPADDYSAVETHEWORLD from '@/components/pegleg-and-paddy-save-the-world'
 import ABOUTTHEAUTHOR from '@/components/about-the-author'
 import LOVE_2 from '@/components/love_2'
 import ADDITIONALCOPYRIGHTINFORMATION from '@/components/additional-copyright-information'
 import IFYOULIKED from '@/components/if-you-liked'
 import OTHERWORDFIREPRESSTITLES from '@/components/other-wordfire-press-titles'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/praise-for-jonathan-maberry",
 			"name" : "praise-for-jonathan-maberry",
 			"component" : PRAISEFORJONATHANMABERRY
 		},
 		{
 			"path" : "/book-description",
 			"name" : "book-description",
 			"component" : BOOKDESCRIPTION
 		},
 		{
 			"path" : "/title-page",
 			"name" : "title-page",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/authors-note",
 			"name" : "authors-note",
 			"component" : AUTHORSNOTE
 		},
 		{
 			"path" : "/chokepoint",
 			"name" : "chokepoint",
 			"component" : CHOKEPOINT
 		},
 		{
 			"path" : "/authors-note-2",
 			"name" : "authors-note-2",
 			"component" : AUTHORSNOTE2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js